
























import { Component, Vue, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponentBackofficeNegociacaoOperadora extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  @Emit('resendAuthorization')
  resendAuthorization() {}

  handleResendAuthorization(reesend: boolean) {
    this.$emit('resendAuthorization', reesend)
  }
}
